import React from 'react';
import { BuyView } from '@shared/ui/checkout/BuyView';
import { MainLayout } from '../layouts';
import { usePageDocumentTitle } from '../hooks/useDocumentTitle';

/** Direct checkout link (/buy/:packageCode) for emails and ads: the shared view in this app's frame. */
const BuyPage: React.FC = () => {
  usePageDocumentTitle('Checkout');
  return (
    <MainLayout>
      <BuyView />
    </MainLayout>
  );
};

export default BuyPage;
